import React from 'react'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import Head from 'next/head'
import HeadMeta from '../components/HeadMeta'
import { GlobalNav } from '../components/GlobalNav'

const OitanaviPage = () => {
  return (
    <div>
      <HeadMeta title="おおいた移住キャンペーン | 株式会社ベツダイ" description="大分への移住・Iターン・Uターン・Jターンをお考えの方向けの物件情報・地域情報をお届けします。" />

      {/* ↓↓↓ ここに追加します ↓↓↓ */}
      <Head>
        <link rel="stylesheet" href="/css/add_oitanavi.css" /> 
      </Head>
      {/* ↑↑↑ ここまで ↑↑↑ */}
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header />
        </div>
        <div className="c-page-sub__globalnav" data-sponly>
          <GlobalNav />
        </div>
        <div className="c-page-sub__hero">
          <div className="c-hero">
            <picture>
              <source srcSet="/img/hero-sp202507.png" media="(max-width: 767px)" /><img src="/img/hero-pc202507.png" alt="どこ住む？なにやる？I・U・Jターンをお考えの方 おおいた移住キャンペーン" />
            </picture>
          </div>
        </div>
        <div className="c-page-sub__main">
          <main>
            <article>
              <div className="c-page-sub__content-main">
                <section data-type="section">
                  <div className="c-oitanavi__about">
                    <div className="c-oitanavi__title">
                      <h2>移住・二拠点生活・<br data-sponly />セカンドハウス・ワーケーション等を<br />検討されている皆さまへ</h2>
                    </div>
                    <ul className="c-oitanavi__about-point2">
                      <li>
                        <p data-label="point">できれば実際に訪れて色々見てみたいけど、<br data-sponly />現地訪問にはお金がかかるし。
                          <br />そんな皆さまのために、ベツダイが別府への移住を<br data-sponly />検討されている方の旅費を補助します。
                          <br />この機会に、日本一<sup>※</sup>の温泉に浸かって、<br data-sponly /> ゆっくり移住を検討してみてはいかがでしょう。
                          <p className="chusyaku_font-size"> <br /><span>※源泉総数及び総湧出量　大分県全国1位　<br data-sponly />出典：「<a href="https://www.env.go.jp/nature/onsen/pdf/2-4_p_1.pdf" target="_blank" className="txt-link">温泉に関するデータ（令和元年度温泉利用状況）</a>」（環境省）</span>
                          </p>
                        </p>
                      </li>
                    </ul>
                    <div className="c-hero">
                      <picture>
                        <source srcSet="/img/details_sp202507.png" media="(max-width: 767px)" /><img src="/img/details_pc202507.png" alt="移住キャンペーン対象" />
                      </picture>
                    </div>
                  </div>
                </section>

                <section data-type="section">
                  <div className="c-oitanavi__about">
                    <div className="c-oitanavi__title">
                      <h2>大分ってこんな場所</h2>
                    </div>
                    <ul className="c-oitanavi__about-point">
                      <li>
                        <p data-label="point">日本一の<br />おんせん県</p>
                        <div className="c-oitanavi__about-point-ph"><img src="/img/oitanavi/pict-about-01.jpg" /></div>
                        <p data-label="detail">県内ほぼすべてで温泉が湧き出る大分県！源泉数、湧出量ともに全国第１位です。</p>
                      </li>
                      <li>
                        <p data-label="point">充実した<br />子育て支援</p>
                        <div className="c-oitanavi__about-point-ph"><img src="/img/oitanavi/pict-about-02.jpg" /></div>
                        <p data-label="detail">「子育て満足度日本一」を目標に、子育て支援の様々な取り組みを進めています。</p>
                      </li>
                      <li>
                        <p data-label="point">定年後も<br />住みやすい街</p>
                        <div className="c-oitanavi__about-point-ph"><img src="/img/oitanavi/pict-about-03.jpg" /></div>
                        <p data-label="detail">「シニア世代が住みたい田舎」としてランクインする市町村がいくつもあるほど魅力の多い街です。</p>
                      </li>
                      <li>
                        <p data-label="point">新鮮な海の幸と<br />豊かな自然</p>
                        <div className="c-oitanavi__about-point-ph"><img src="/img/oitanavi/pict-about-04.jpg" /></div>
                        <p data-label="detail">海あり山あり、大自然に囲まれ空気も美味しい大分。自然の恵みたっぷりの郷土料理も絶品です。</p>
                      </li>
                    </ul>
                    <ul className="c-oitanavi__about-area">
                      <li>
                        <div className="c-oitanavi__about-area-ph">
                          <p data-label="area" data-area="oita">大分市</p>
                          <div className="c-oitanavi__about-area-ph-contain"><img src="/img/oitanavi/pict-about-oita.jpg" /></div>
                        </div>
                        <p data-label="detail">48万人の市民が暮らす県都。優れた都市基盤と海・山・川の自然の恵みその両方をバランス良く兼ね備えた街は様々なライフステージにぴったりです。</p>
                      </li>
                      <li>
                        <div className="c-oitanavi__about-area-ph">
                          <p data-label="area" data-area="beppu">別府市</p>
                          <div className="c-oitanavi__about-area-ph-contain"><img src="/img/oitanavi/pict-about-beppu.jpg" /></div>
                        </div>
                        <p data-label="detail">日本一の湧出量と源泉数を誇る別府市。古くから日本を代表する温泉地として賑わい、歴史と文化あふれる国際観光温泉文化都市です。</p>
                      </li>
                      <li>
                        <div className="c-oitanavi__about-area-ph">
                          <p data-label="area" data-area="usuki">臼杵市</p>
                          <div className="c-oitanavi__about-area-ph-contain"><img src="/img/oitanavi/pict-about-usuki.jpg" /></div>
                        </div>
                        <p data-label="detail">海も山も近いコンパクトシティ。きめ細やかな移住支援が実を結び、移住者数は1,000人を突破！新規就農や有機農業を考えている方におすすめです。</p>
                      </li>
                      <li>
                        <div className="c-oitanavi__about-area-ph">
                          <p data-label="area" data-area="hasama">由布市挾間</p>
                          <div className="c-oitanavi__about-area-ph-contain"><img src="/img/oitanavi/pict-about-hasama.jpg" /></div>
                        </div>
                        <p data-label="detail">大分市に隣接する利便性の高いエリア。自然に囲まれながらも生活環境が整い、都市と田舎のちょうどよさを実感できる街は、子育て世代や移住希望者に選ばれています。</p>
                      </li>
                    </ul>
                  </div>
                </section>

                {/*
                <section data-type="section">
                  <div className="c-oitanavi__voice">
                    <div className="c-oitanavi__title">
                      <h2>移住者の声</h2>
                    </div>
                    <ul className="c-oitanavi__voice-person">
                      <li><a href="/oitanavi/voice/01.html">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-01.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="beppu">別府市</p>
                            <p data-label="title">温泉や公園も充実。<br />温かく穏やかな毎日がここにはあります。</p>
                            <p data-label="name">宮井智史 様</p>
                          </div></a></li>
                      <li><a href="#">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-02.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="oita">大分市</p>
                            <p data-label="title">憧れだった「おんせん県」での暮らし。<br />新しい趣味を楽しんでいます。</p>
                            <p data-label="name">S 様</p>
                          </div></a></li>
                      <li><a href="#">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-03.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="beppu">別府市</p>
                            <p data-label="title">転勤を繰り返し、ついに手に入れた、<br />家族との穏やかで温かな日々。</p>
                            <p data-label="name">K様ご家族</p>
                          </div></a></li>
                      <li><a href="#">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-04.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="usuki">臼杵市</p>
                            <p data-label="title">２ヶ月で決めたスピード移住。<br />引き継いだ農業経営。</p>
                            <p data-label="name">I 様</p>
                          </div></a></li>
                      <li><a href="#">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-05.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="beppu">別府市</p>
                            <p data-label="title">移住のきっかけは、<br />老後は好きな場所でという思いから。</p>
                            <p data-label="name">指原 勇様</p>
                          </div></a></li>
                      <li><a href="#">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-06.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="beppu">別府市</p>
                            <p data-label="title">利便性と豊かな自然を両立する<br />新築マンションで新たな暮らし。</p>
                            <p data-label="name">K様ご家族</p>
                          </div></a></li>
                      <li className="c-oitanavi__voice-person-acordion" data-sponly><a href="/oitanavi/voice/01.html">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-01.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="beppu">別府市</p>
                            <p data-label="title">温泉や公園も充実。<br />温かく穏やかな毎日がここにはあります。</p>
                            <p data-label="name">宮井智史 様</p>
                          </div></a></li>
                      <li className="c-oitanavi__voice-person-acordion" data-sponly><a href="#">
                          <div className="c-oitanavi__voice-person-ph"><img src="/img/oitanavi/pict-voice-02.jpg" /></div>
                          <div className="c-oitanavi__voice-person-text">
                            <p data-label="area" data-area="oita">大分市</p>
                            <p data-label="title">憧れだった「おんせん県」での暮らし。<br />新しい趣味を楽しんでいます。</p>
                            <p data-label="name">S 様</p>
                          </div></a></li>
                    </ul>
                    <button className="c-oitanavi__voice-person-button" data-pconly><a href="/voice/">もっと見る</a></button>
                  </div>
                </section>
                */}
                <section data-type="section">
                  <div className="c-oitanavi__recommend">
                    <div className="c-oitanavi__title">
                      <h2>キャンペーン対象</h2>
                    </div>
                    <div className="c-oitanavi__recommend-block" data-type="campaign">
                      <div className="c-oitanavi__recommend-block-item" data-item="2col">
                        <div data-label="text">
                          <h4>新築マンション</h4>
                          <p>住む人と時代にジャストマッチする暮らしを提供するマンションシリーズ「グリーンヒル」</p><a href="https://betsudai.co.jp/service-greenhill/" target="_blank"><img src="/img/oitanavi/logo-greenhill.png" alt="GREEN HILL" /></a>
                        </div>
                        <div data-label="text">
                          <h4>新築戸建</h4>
                          <p>多彩なラインナップで、お好みの住まいがきっと見つかります。モデルハウス・見学会情報も多数掲載。</p><a href="https://betsudaihome.jp/" target="_blank"><img src="/img/oitanavi/logo-betsudai-oita.png" alt="BETSUDAI HOME 大分" /></a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="yufu_campaign">
                    <img className='pcOnly' src="/img/oitanavi/yufu_campaign.png" alt="由布市移住応援キャンペーン" />
                    <img className='spOnly' src="/img/oitanavi/yufu_campaign_sp.png" alt="由布市移住応援キャンペーン" />
                    <div className="yufu_campaign_link">
                      <a href="https://betsudaihome.jp/events/2604_akano01-05" target='_blank'>
                      <span>
                        由布市移住応援キャンペーン
                      </span>
                      対象物件はこちら
                      </a>
                    </div>
                  </div>

                </section>
                <section data-type="section">
                  <div className="c-oitanavi__recommend">
                    <div className="c-oitanavi__title">
                      <h2>おすすめの住まい</h2>
                    </div>
                    <div className="c-oitanavi__recommend-block" data-type="single">
                      <h3>単身者におすすめ</h3>
                      <div className="c-oitanavi__recommend-block-item" data-item="1col">
                        <div data-label="text">
                          <h4>賃貸</h4>
                          <p>大分市中心部・周辺部、別府市の賃貸物件を<br data-pconly />お探しの方に。様々な条件にもお応えしています。</p><a href="https://rent.betsudai.jp/" target="_blank"><img src="/img/oitanavi/logo-betsudai-chintai.png" alt="ベツダイの賃貸" /></a>
                        </div>
                        <div data-label="ph"><img src="/img/oitanavi/pict-recommend-01.jpg" /></div>
                      </div>
                    </div>
                    <div className="c-oitanavi__recommend-block" data-type="family">
                      <h3>ファミリーにおすすめ</h3>
                      <div className="c-oitanavi__recommend-block-item" data-item="2col">
                        <div data-label="text">
                          <h4>賃貸</h4>
                          <p>大分市中心部・周辺部、別府市の賃貸物件を<br data-pconly />お探しの方に。様々な条件にもお応えしています。</p><a href="https://rent.betsudai.jp/" target="_blank"><img src="/img/oitanavi/logo-betsudai-chintai.png" alt="ベツダイの賃貸" /></a>
                        </div>
                        <div data-label="text">
                          <h4>新築マンション</h4>
                          <p>住む人と時代にジャストマッチする暮らしを提供するマンションシリーズ「グリーンヒル」</p><a href="https://betsudai.co.jp/service-greenhill/" target="_blank"><img src="/img/oitanavi/logo-greenhill.png" alt="GREEN HILL" /></a>
                        </div>
                        <div data-label="text">
                          <h4>新築戸建</h4>
                          <p>多彩なラインナップで、お好みの住まいがきっと見つかります。モデルハウス・見学会情報も多数掲載。</p><a href="https://betsudaihome.jp/" target="_blank"><img src="/img/oitanavi/logo-betsudai-oita.png" alt="BETSUDAI HOME 大分" /></a>
                        </div>
                        <div data-label="text">
                          <h4>中古戸建・中古マンション</h4>
                          <p>住みたいエリアから物件を探してリノベーション。<br data-pconly />中古住宅専門のアドバイザーがご提案いたします。</p>
                          {/* <a href="https://ok.hhplz.com/" target="_blank"><img src="/img/oitanavi/logo-homehouseplaza.png" alt="HOME HOUSE PLAZA" /></a> */}
                          <a className="mb20" href="https://portal.betsudai.jp/" target="_blank"><img src="/img/logo-betsudaiportal.png" height={30} alt="不動産ポータルサイト" width={213} /></a>
                          {/* <p className="chusyaku_font-size">HOME HOUSE PLAZAは5月末をもちまして不動産ポータルサイトに統合リニューアルされます。</p> */}
                        </div>
                      </div>
                    </div>
                    <div className="c-oitanavi__recommend-block" data-type="senior">
                      <h3>シニアにおすすめ</h3>
                      <div className="c-oitanavi__recommend-block-item" data-item="2col">
                        <div data-label="text">
                          <h4>新築マンション</h4>
                          <p>住む人と時代にジャストマッチする暮らしを提供するマンションシリーズ「グリーンヒル」</p><a href="https://betsudai.co.jp/service-greenhill/" target="_blank"><img src="/img/oitanavi/logo-greenhill.png" alt="GREEN HILL" /></a>
                        </div>
                        <div data-label="text">
                          <h4>中古戸建・中古マンション</h4>
                          <p>住みたいエリアから物件を探してリノベーション。<br data-pconly />中古住宅専門のアドバイザーがご提案いたします。</p>
                          {/* <a href="https://ok.hhplz.com/" target="_blank"><img src="/img/oitanavi/logo-homehouseplaza.png" alt="HOME HOUSE PLAZA" /></a> */}
                          <a className="mb20" href="https://portal.betsudai.jp/" target="_blank"><img src="/img/logo-betsudaiportal.png" height={30} alt="不動産ポータルサイト" width={213} /></a>
                          {/* <p className="chusyaku_font-size">HOME HOUSE PLAZAは5月末をもちまして不動産ポータルサイトに統合リニューアルされます。</p> */}
                        </div>
                      </div>
                      <div className="c-oitanavi__recommend-block-item" data-item="1col">
                        <div data-label="text">
                          <h4>新築戸建</h4>
                          <p>多彩なラインナップで、お好みの住まいがきっと見つかります。モデルハウス・見学会情報も多数掲載。</p>
                          <div className="c-oitanavi__recommend-block-logo"><a href="https://betsudaihome.jp/" target="_blank"><img src="/img/oitanavi/logo-betsudai-oita.png" alt="BETSUDAI HOME 大分" /></a></div>
                        </div>
                        <div data-label="ph"><img src="/img/oitanavi/pict-recommend-02.jpg" /></div>
                      </div>
                    </div>
                  </div>
                </section>
                <section data-type="section">
                  <div className="c-oitanavi__support">
                    <div className="c-oitanavi__title">
                      <h2>サポート情報</h2>
                    </div>
                    <ul className="c-oitanavi__support-bnr">
                      <li data-item="2col"><a href="https://www.iju-oita.jp/" target="_blank"><img src="/img/oitanavi/bnr-oitakurashi.jpg" alt="大分県移住・交流ポータルサイト おおいた暮らし" /></a></li>
                      <li data-item="2col"><a href="https://www.iju-oita.jp/step#section-01" target="_blank"><img src="/img/oitanavi/bnr-ijyupanf.jpg" alt="おおいた暮らしへの第一歩！ おおいた移住パンフレット" /></a></li>
                      <li data-item="1col" className="mb20"><a href="https://www.city.kunisaki.oita.jp/soshiki/machizukuri/soraniwa-gaiyou.html" target="__blank">
                        <picture>
                          <source srcSet="/img/oitanavi/sp_soraniwa.png" media="(max-width: 767px)" /><img src="/img/oitanavi/pc_soraniwa.png" alt="そらにわの丘" />
                        </picture></a>
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default OitanaviPage
